import React, { useState } from "react";
import "./navbar.css";
import logo from "../../assets/images/logo.png";
import { useTranslation } from "../../shared/LanguageContext";

const AboutModal = ({ show, onClose }) => {
  const { t } = useTranslation();
  if (!show) return null;
  return (
    <div className="about-modal-overlay" onClick={onClose}>
      <div className="about-modal-content" onClick={e => e.stopPropagation()}>
        <button className="about-modal-close" onClick={onClose}>&times;</button>
        <h2>{t("about_title")}</h2>
        <h4>{t("about_subtitle")}</h4>
        <p>
          Добро пожаловать в кардиологический центр нового поколения – OQ SAROY hospital в Шахризабзе! Мы открываем новую эру в лечении сердечно-сосудистых заболеваний в Узбекистане.<br /><br />
          <b>Наше ключевое отличие</b> – ведущие специалисты-кардиологи и кардиохирурги из Москвы, привносящие многолетний опыт работы в лучших клиниках России и применение самых современных мировых протоколов.<br /><br />
          В OQ SAROY Cardio доступны уникальные методы диагностики и лечения:
        </p>
        <ul>
          <li><b>Криоаблация устьев легочных вен:</b> золотой стандарт лечения мерцательной аритмии.</li>
          <li><b>Ротаблация:</b> восстановление кровотока при тяжелом кальцинозе артерий.</li>
          <li><b>Внутрисосудистая диагностика:</b> FFR, iFR, IVUS для точных решений и планирования операций.</li>
        </ul>
        <p>
          <b>Почему OQ SAROY Cardio?</b><br />
          – Эксперты из Москвы<br />
          – Эксклюзивные технологии<br />
          – Точная диагностика<br />
          – Комплексный подход<br />
          – Международные стандарты<br />
          – Комфорт и доступность<br /><br />
          <b>OQ SAROY Cardio</b> – ваш шанс получить лечение экспертного уровня с применением технологий будущего, не покидая Узбекистан!
        </p>
        <p style={{ marginTop: 18, fontWeight: 500, color: "#5354a0" }}>
          Запишитесь на консультацию или диагностику уже сегодня!
        </p>
      </div>
    </div>
  );
};

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const { t, language, setLanguage } = useTranslation();

  const handleMenuClick = () => setMenuOpen(false);

  return (
    <>
      <nav className="navbar-container">
        {/* Логотип */}
        <div className="logo-with-btn">
          <div className="logo">
            <img src={logo} alt="medic-logo" />
          </div>

          <a
            href="http://aisp.uz/4ndn2p/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="about-btn">
              {t("nav_test_risk")}
            </button>
          </a>
        </div>

        {/* Меню */}
        <div className={`nav-items ${menuOpen ? "open" : ""}`}>
          <h3 onClick={handleMenuClick}><a href="#services">{t("nav_services")}</a></h3>
          <h3 onClick={handleMenuClick}><a href="#docs">{t("nav_docs")}</a></h3>
          <h3 onClick={handleMenuClick}><a href="#facils">{t("nav_facilities")}</a></h3>
          <h3 onClick={handleMenuClick}><a href="#contacts">{t("nav_contacts")}</a></h3>
          <h3>
            <button className="about-btn" onClick={() => { setMenuOpen(false); setModalOpen(true); }}>{t("nav_about")}</button>
          </h3>
          
          <div className="lang-switcher">
            <button 
              className={`lang-btn ${language === 'ru' ? 'active' : ''}`} 
              onClick={() => setLanguage('ru')}
            >
              RU
            </button>
            <span style={{color: 'white', margin: '0 5px'}}>|</span>
            <button 
              className={`lang-btn ${language === 'uz' ? 'active' : ''}`} 
              onClick={() => setLanguage('uz')}
            >
              UZ
            </button>
          </div>
        </div>

        {/* Бургер */}
        <div
          className={`burger ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span />
          <span />
          <span />
        </div>
      </nav>
      <AboutModal show={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
};

export default Navbar;
